var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 20.25C12.4319 20.25 13.6022 20.0172 14.6942 19.5649C15.7861 19.1126 16.7782 18.4497 17.614 17.614C18.4497 16.7782 19.1126 15.7861 19.5649 14.6942C20.0172 13.6022 20.25 12.4319 20.25 11.25C20.25 10.0681 20.0172 8.89778 19.5649 7.80585C19.1126 6.71392 18.4497 5.72177 17.614 4.88604C16.7782 4.05031 15.7861 3.38738 14.6942 2.93508C13.6022 2.48279 12.4319 2.25 11.25 2.25C8.86305 2.25 6.57387 3.19821 4.88604 4.88604C3.19821 6.57387 2.25 8.86305 2.25 11.25C2.25 13.6369 3.19821 15.9261 4.88604 17.614C6.57387 19.3018 8.86305 20.25 11.25 20.25ZM10.033 7.24L15.677 10.376C15.8328 10.4626 15.9626 10.5893 16.053 10.743C16.1434 10.8967 16.1911 11.0717 16.1911 11.25C16.1911 11.4283 16.1434 11.6033 16.053 11.757C15.9626 11.9107 15.8328 12.0374 15.677 12.124L10.033 15.26C9.85025 15.3616 9.64413 15.4136 9.43506 15.411C9.22599 15.4084 9.02123 15.3513 8.84107 15.2452C8.6609 15.1391 8.51159 14.9877 8.40791 14.8062C8.30424 14.6246 8.2498 14.4191 8.25 14.21V8.29C8.2498 8.08092 8.30424 7.87541 8.40791 7.69384C8.51159 7.51227 8.6609 7.36094 8.84107 7.25484C9.02123 7.14874 9.22599 7.09156 9.43506 7.08895C9.64413 7.08635 9.85025 7.13842 10.033 7.24Z",
    fill: "#51ACED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoBtn);
export default __webpack_public_path__ + "static/media/videoBtn.4c7da5e47f97f79a6dddf02dac8340b6.svg";
export { ForwardRef as ReactComponent };